import axios from 'axios'
import { getIsInsideBillma } from '@/iframeContext'

const API_BASE_URL = process.env.API_HOST || 'http://localhost:8081/'

const publicHttpClient = axios.create({ baseURL: API_BASE_URL })

publicHttpClient.interceptors.request.use(function (config) {
  if (getIsInsideBillma()) {
    config.headers['X-From-Iframe'] = 'true'
  }
  return config
})

publicHttpClient.interceptors.response.use(function (response) {
  return Promise.resolve(response.data)
}, function (error) {
  if (error.response.status === 401) {
    window.location.replace('/logout')
  }
  return Promise.reject(error)
})

export default publicHttpClient
